export default "__VITE_ASSET__CNXnWVOw__"